import { AnyAction } from 'redux';
import { ExpectedRealizedDTO } from '../../models/dto/ExpectedRealizedDTO';
import { PunchCardDetailsChartDTO } from '../../models/dto/PunchCardDetailsDTO';
import { authenticationActionTypes } from '../actions/authActions';
import { chartsActionsTypes } from '../actions/chartsActions';

export interface ChartsReducerData {
  loadingExpectedRealized: boolean;
  loadingPunchCardDetails: boolean;
  punchCardDetails: PunchCardDetailsChartDTO[];
  expectedRealized: ExpectedRealizedDTO[];
}

const INITIAL_STATE = {
  loadingExpectedRealized: false,
  loadingPunchCardDetails: false,
  punchCardDetails: [],
  expectedRealized: [],
};

export default (
  state: ChartsReducerData = INITIAL_STATE,
  action: AnyAction,
): ChartsReducerData => {
  switch (action.type) {
    case chartsActionsTypes.GET_EXPECTED_REALIZED:
      return {
        ...state,
        loadingExpectedRealized: true,
      };

    case chartsActionsTypes.GET_EXPECTED_REALIZED_SUCCESS:
      return {
        ...state,
        loadingExpectedRealized: false,
        expectedRealized: action.payload,
      };

    case chartsActionsTypes.GET_EXPECTED_REALIZED_FAILURE:
      return {
        ...state,
        expectedRealized: [],
        loadingExpectedRealized: false,
      };

    case chartsActionsTypes.GET_PUNCH_CARD_DETAILS:
      return {
        ...state,
        loadingPunchCardDetails: true,
      };

    case chartsActionsTypes.GET_PUNCH_CARD_DETAILS_SUCCESS:
      return {
        ...state,
        loadingPunchCardDetails: false,
        punchCardDetails: action.payload,
      };

    case chartsActionsTypes.GET_PUNCH_CARD_DETAILS_FAILURE:
      return {
        ...state,
        punchCardDetails: [],
        loadingPunchCardDetails: false,
      };

    case authenticationActionTypes.LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
};
